import { cn } from '@/lib/utils';

const STATUS_CLASSES: Record<string, string> = {
  draft: 'border-border bg-muted text-muted-foreground',
  approving: 'border-sky-500/30 bg-sky-500/10 text-sky-700',
  signed: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-700',
  done: 'border-teal-500/30 bg-teal-500/10 text-teal-700',
  terminated: 'border-red-500/30 bg-red-500/10 text-red-700',
  overdue: 'border-red-500/30 bg-red-500/10 text-red-700',
  today: 'border-amber-500/30 bg-amber-500/10 text-amber-700',
  soon: 'border-amber-500/25 bg-amber-500/10 text-amber-700',
  planned: 'border-violet-500/25 bg-violet-500/10 text-violet-700',
  registered: 'border-border bg-muted text-muted-foreground',
};

export function SedStatusChip({
  code,
  label,
  fromRoute = false,
  className,
}: {
  code: string;
  label: string;
  fromRoute?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex max-w-full items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium leading-4',
        STATUS_CLASSES[code] || 'border-border bg-muted text-muted-foreground',
        className,
      )}
    >
      <span className="truncate">{label || 'Без статуса'}</span>
      {fromRoute && <span className="shrink-0 opacity-70">· маршрут</span>}
    </span>
  );
}
